import React, { useEffect, useRef } from "react";
import { Box, Flex } from "@radix-ui/themes";

const BAR_COUNT = 4;

const getRandomHeight = (min, max) => Math.random() * (max - min) + min;

export default function AudioVisualizer({
  start = false,
  color = "#fff",
  background = "#222",
  size = 40,
  barWidth = 3,
  barSpacing = 0.1,
  minHeight = 4, // dot size
  maxHeight = 22,
  border = "2px solid #fff",
}) {
  const barsRef = useRef([]);
  const prevHeights = useRef(Array(BAR_COUNT).fill(minHeight));
  const intervalRef = useRef();

  useEffect(() => {
    if (start) {
      intervalRef.current = setInterval(() => {
        barsRef.current.forEach((bar, i) => {
          if (bar) {
            const newHeight = getRandomHeight(minHeight, maxHeight);
            const prevHeight = prevHeights.current[i];
            bar.style.transition =
              newHeight > prevHeight
                ? "height 1s cubic-bezier(0.4,0,0.2,1), margin-top 1s cubic-bezier(0.4,0,0.2,1)"
                : "height 0.2s cubic-bezier(0.4,0,0.2,1), margin-top 0.2s cubic-bezier(0.4,0,0.2,1)";
            bar.style.height = `${newHeight}px`;
            bar.style.marginTop = `${-(newHeight / 2)}px`;
            prevHeights.current[i] = newHeight;
          }
        });
      }, 150);
    } else {
      // Reset to static dot
      barsRef.current.forEach((bar, i) => {
        if (bar) {
          bar.style.transition =
            "height 0.2s cubic-bezier(0.4,0,0.2,1), margin-top 0.2s cubic-bezier(0.4,0,0.2,1)";
          bar.style.height = `${minHeight}px`;
          bar.style.marginTop = `${-(minHeight / 2)}px`;
          prevHeights.current[i] = minHeight;
        }
      });
    }
    return () => intervalRef.current && clearInterval(intervalRef.current);
  }, [start, minHeight, maxHeight]);

  return (
    <Box
      style={{
        width: size,
        height: size,
        background,
        border,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        bottom: window.innerWidth < 768 ? "10%" : 8,
        right: window.innerWidth < 768 ? "29%" : 8,
        zIndex: 10,
      }}
    >
      <Flex
        direction="row"
        align="center"
        justify="center"
        style={{
          width: "60%",
          height: "100%",
          gap: size * barSpacing,
          position: "relative",
        }}
      >
        {[...Array(BAR_COUNT)].map((_, i) => (
          <Box
            key={i}
            ref={(el) => (barsRef.current[i] = el)}
            style={{
              width: barWidth,
              height: minHeight,
              background: color,
              borderRadius: barWidth,
              position: "absolute",
              left: `${i * (barWidth + size * barSpacing)}px`,
              top: "50%",
              marginTop: `-${minHeight / 2}px`,
              transition:
                "height 0.2s cubic-bezier(0.4,0,0.2,1), margin-top 0.2s cubic-bezier(0.4,0,0.2,1)",
            }}
          />
        ))}
      </Flex>
    </Box>
  );
}
